import * as Sentry from "@sentry/react";
import type { AnyRouter } from "@tanstack/react-router";

export const initSentry = (router: AnyRouter): void => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.browserProfilingIntegration(),
    ],
    // エラーは全件キャプチャ
    sampleRate: 1.0,
    // トレーシング・プロファイリングは本番 1%、開発 100%
    tracesSampleRate: import.meta.env.PROD ? 0.01 : 1.0,
    // 実効プロファイリングレート: 本番 0.01%（0.01 * 0.01）、開発 100%
    profilesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend(event) {
      if (event.level === "info") return null;
      // 通話・購入関連エラーは全件送信
      if (event.tags?.feature === "call") return event;
      if (event.tags?.feature === "purchase") return event;
      // その他は 1% サンプリング（コスト・ノイズ削減）
      if (Math.random() > 0.01) return null;
      return event;
    },
    debug: false,
  });
};
